<div class="gs" *ngIf="sheet() as s">
  <header class="gs-head">
    <div class="gs-head-top">
      <h2 class="gs-name">{{ s.name }}</h2>
      <span class="gs-privacy" [class.gs-privacy--private]="s.privacy !== 'public'">
        {{ (s.privacy === 'public' ? 'groupsManagement.public' : 'groupsManagement.private') | translate }}
      </span>
    </div>
    <p class="gs-context">
      {{ s.sportName }}<ng-container *ngIf="s.locationName"> · {{ s.locationName }}</ng-container>
      <ng-container *ngIf="s.createdAt"> · {{ 'groupSheet.createdOn' | translate }} {{ s.createdAt | date: 'dd/MM/yyyy' }}</ng-container>
      <ng-container *ngIf="s.owner"> {{ 'groupSheet.by' | translate }} {{ s.owner.name }}</ng-container>
    </p>
  </header>

  <div class="gs-kpis">
    <div class="gs-kpi">
      <span class="gs-kpi-value">{{ s.membersTotal }}</span>
      <span class="gs-kpi-label">{{ 'groupSheet.membersOf' | translate: { active: s.membersActive90 } }}</span>
    </div>
    <div class="gs-kpi">
      <span class="gs-kpi-value">{{ s.activitiesTotal }}</span>
      <span class="gs-kpi-label">{{ 'groupSheet.activitiesCreated' | translate }}</span>
    </div>
    <div class="gs-kpi">
      <span class="gs-kpi-value">{{ s.joinedSharePct !== null ? s.joinedSharePct + ' %' : '—' }}</span>
      <span class="gs-kpi-label">{{ 'groupSheet.joinedShare' | translate }}</span>
    </div>
    <div class="gs-kpi">
      <span class="gs-kpi-value">{{ daysSince(s.lastActivityAt) !== null ? ('groupSheet.daysAgo' | translate: { days: daysSince(s.lastActivityAt) }) : '—' }}</span>
      <span class="gs-kpi-label">{{ 'groupSheet.lastActivity' | translate }}</span>
    </div>
    <div class="gs-kpi" [class.gs-kpi--alert]="s.admins.length === 0">
      <span class="gs-kpi-value">{{ s.admins.length }}</span>
      <span class="gs-kpi-label">{{ 'groupSheet.namedAdmins' | translate }}</span>
    </div>
  </div>

  <p class="gs-signal" *ngIf="signal_() as sig"
     [class.gs-signal--alert]="sig.tone === 'alert'"
     [class.gs-signal--mixed]="sig.tone === 'mixed'"
     [class.gs-signal--good]="sig.tone === 'good'">
    <strong>{{ 'groupSheet.signal' | translate }} :</strong> {{ sig.text }}
  </p>

  <section class="gs-card">
    <h3>{{ 'groupSheet.ownerAndAdmins' | translate }}</h3>
    <div class="gs-person" *ngIf="s.owner">
      <span class="gs-person-tag">{{ 'groupSheet.creator' | translate }}</span>
      <a [routerLink]="['/users', s.owner.id]" class="gs-person-name">{{ s.owner.name }}</a>
      <span class="gs-person-days" *ngIf="s.owner.daysSinceLastAction !== null">{{ 'groupSheet.activeAgo' | translate: { days: s.owner.daysSinceLastAction } }}</span>
    </div>
    <div class="gs-person" *ngFor="let admin of s.admins">
      <span class="gs-person-tag gs-person-tag--admin">{{ 'groupSheet.admin' | translate }}</span>
      <a [routerLink]="['/users', admin.id]" class="gs-person-name">{{ admin.name }}</a>
      <span class="gs-person-days" *ngIf="admin.daysSinceLastAction !== null">{{ 'groupSheet.activeAgo' | translate: { days: admin.daysSinceLastAction } }}</span>
    </div>
    <p class="gs-empty" *ngIf="s.admins.length === 0">{{ 'groupSheet.noAdmin' | translate }}</p>
  </section>

  <section class="gs-card">
    <h3>{{ 'groupSheet.recentActivities' | translate }}</h3>
    <ul class="gs-activities" *ngIf="s.recentActivities.length; else gsNoAct">
      <li *ngFor="let activity of s.recentActivities">
        <span class="gs-act-title">{{ activity.title }}</span>
        <span class="gs-act-meta">{{ activity.startDate | date: 'dd/MM' }} ·
          <ng-container *ngIf="activity.partners > 0">{{ 'groupSheet.partners' | translate: { count: activity.partners } }}</ng-container>
          <span class="gs-act-nobody" *ngIf="activity.partners === 0">{{ 'groupSheet.nobody' | translate }}</span>
        </span>
      </li>
    </ul>
    <ng-template #gsNoAct><p class="gs-empty">{{ 'groupSheet.noActivity' | translate }}</p></ng-template>
  </section>

  <section class="gs-card">
    <h3>{{ 'groupSheet.members' | translate }} ({{ s.membersTotal }})</h3>
    <ul class="gs-members" *ngIf="s.members.length; else gsNoMembers">
      <li *ngFor="let member of s.members">
        <a [routerLink]="['/users', member.id]" class="gs-person-name">{{ member.name }}</a>
        <span class="gs-heat" [ngClass]="'gs-heat--' + member.heat">{{ 'usersManagement.temperature.' + member.heat | translate }}</span>
      </li>
    </ul>
    <ng-template #gsNoMembers><p class="gs-empty">{{ 'groupSheet.noMembers' | translate }}</p></ng-template>
    <p class="gs-more" *ngIf="s.membersMore > 0">{{ 'groupSheet.moreMembers' | translate: { count: s.membersMore } }}</p>
  </section>

  <section class="gs-card" *ngIf="s.description">
    <h3>{{ 'groupSheet.description' | translate }}</h3>
    <p class="gs-description">{{ s.description }}</p>
    <p class="gs-more" *ngIf="s.hasCover">{{ 'groupSheet.hasCover' | translate }}</p>
  </section>

  <div class="gs-actions">
    <button pButton type="button" icon="pi pi-pencil" [label]="'groupsManagement.editGroup' | translate" (click)="editRequested.emit()"></button>
    <button pButton type="button" icon="pi pi-megaphone" class="p-button-outlined" [label]="'groupEngage.title' | translate" (click)="engageRequested.emit()"></button>
    <button pButton type="button" icon="pi pi-trash" class="p-button-outlined p-button-danger" [label]="'groupsManagement.deleteGroup' | translate" (click)="deleteRequested.emit()"></button>
  </div>
</div>

<p class="gs-loading" *ngIf="loading()">{{ 'groupSheet.loading' | translate }}</p>
<p class="gs-failed" *ngIf="failed()">{{ 'groupSheet.failed' | translate }}</p>
